import { Accordion } from "@/components/ui/library/accordion";
import { useState } from "react";
import { useChildForm } from "@/features/leads/contexts/ChildProvider";
import AcademyChildItem from "./AcademyChildItem";

export default function AcademyAccordion() {
  const [openValue, setOpenValue] = useState<string | undefined>(undefined);
  const { currentChildsOnSelectedStage } = useChildForm();
  const { child: activeChild } = useChildForm();

  return (
    <Accordion
      type="single"
      collapsible
      className="w-full"
      value={openValue}
      onValueChange={setOpenValue}
    >
      {currentChildsOnSelectedStage?.map((child: any) => {
        const childId = String(child.id);
        const isOpen = openValue === childId;
        const isCurrentChild = activeChild?.id === child.id;
        const enrichedChild = isCurrentChild
          ? { ...child, ...activeChild }
          : child;
        return (
          <AcademyChildItem
            key={childId}
            child={enrichedChild}
            isOpen={isOpen}
            isCurrentChild={isCurrentChild}
          />
        );
      })}
    </Accordion>
  );
}
